const Rules = () => {
  return (
    <>
      <h1>rules</h1>
    </>
  );
};
export default Rules;
